"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModuleRegistry = void 0;
const generateGUID_1 = require("../utils/guid/generateGUID");
const ReactModuleContainerErrors_1 = require("./ReactModuleContainerErrors");
class ModuleRegistry {
    constructor() {
        this.cleanAll();
    }
    cleanAll() {
        this.registeredComponents = {};
        this.registeredMethods = new Map();
        this.eventListeners = {};
        this.modules = {};
    }
    registerModule(globalId, ModuleFactory, args = []) {
        if (this.modules[globalId]) {
            throw new Error(`A module with id "${globalId}" is already registered`);
        }
        this.modules[globalId] = new ModuleFactory(...args);
    }
    getModule(globalId) {
        return this.modules[globalId];
    }
    getAllModules() {
        return Object.keys(this.modules).map((moduleId) => this.modules[moduleId]);
    }
    registerComponent(globalId, generator) {
        this.registeredComponents[globalId] = generator;
    }
    component(globalId) {
        const generator = this.registeredComponents[globalId];
        if (!generator) {
            this.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.UnregisteredComponentUsedError(globalId));
            return;
        }
        return generator();
    }
    addListener(globalId, callback) {
        const callbackKey = `eventListener_${(0, generateGUID_1.generateGUID)()}`;
        this.eventListeners[globalId] = this.eventListeners[globalId] || {};
        this.eventListeners[globalId][callbackKey] = callback;
        return {
            remove: () => {
                if (this.eventListeners[globalId]) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.eventListeners[globalId][callbackKey];
                }
            },
        };
    }
    notifyListeners(globalId, ...args) {
        const listenerCallbacks = this.eventListeners[globalId];
        if (!listenerCallbacks) {
            return;
        }
        Object.values(listenerCallbacks).forEach((callback) => invokeSafely(globalId, callback, args));
    }
    registerMethod(globalId, generator) {
        this.registeredMethods.set(globalId, generator);
    }
    invoke(methodGlobalId, ...args) {
        const generator = this.registeredMethods.get(methodGlobalId);
        if (!generator) {
            this.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.UnregisteredMethodInvokedError(methodGlobalId));
            return;
        }
        const method = generator();
        return method(...args);
    }
}
function invokeSafely(globalId, callback, args) {
    try {
        callback(...args);
    }
    catch (err) {
        moduleRegistry.notifyListeners('reactModuleContainer.error', new ReactModuleContainerErrors_1.ListenerCallbackError(globalId, err));
    }
}
let moduleRegistry;
// to avoid memory leaks in SSR, module registry should be created on demand
const getModuleRegistry = () => {
    if (!moduleRegistry) {
        if (typeof window !== 'undefined') {
            // @ts-expect-error
            window.ModuleRegistry = window.ModuleRegistry || new ModuleRegistry();
            // @ts-expect-error
            moduleRegistry = window.ModuleRegistry;
        }
        else {
            moduleRegistry = new ModuleRegistry();
        }
    }
    return moduleRegistry;
};
exports.getModuleRegistry = getModuleRegistry;
//# sourceMappingURL=ModuleRegistry.js.map